import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/index';
import {HttpClient,HttpHeaders} from '@angular/common/http';
import {tap} from 'rxjs/internal/operators';
import {isUndefined} from 'util';

@Injectable({
  providedIn: 'root'
})
export class BackendApiService {
  backendUrlHistory: any = "https://admin.bbmarket.in/api/v1/"; 
  //backendUrl: any = "https://service.dgexch.com/api/v1/";  //staging
  backendUrl: any = "https://service.dgpluslive.com/api/v1/";  //live 
  //backendUrl: any = "http://localhost:5050/api/v1/";  //local
  constructor(private http: HttpClient) { }
 
  getHistoryData(data): Observable<any> {
      return this.http.post(this.backendUrlHistory + 'instruments/instrument-history' ,data)
      .pipe(tap(_ => console.log(`instrument history successfully`)));
  }
  checkAuthToken(data): Observable<any> {
    return this.http.post(this.backendUrl + 'user/checkAuthToken' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  badlaInstruments(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/badla/get-records' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getBadlaOrder(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getBadlaOrder' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getBadlaOrderOld(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getBadlaOrderOld' ,data)
    .pipe(tap(_ => console.log(``)));
  }

  getBadlaOrderGroup(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getBadlaOrderGroup' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  badlaReport(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getBadlaReport' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getOrderPL(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getOrderPL' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getOrderPLOld(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getOrderPLOld' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  changeTheme(data):Observable<any> {
    return this.http.post(this.backendUrl + 'user/chnageThemeBadla' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getTheme(data):Observable<any> {
    return this.http.post(this.backendUrl + 'user/getThemeBadla' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getUserDollerRate(data):Observable<any> {
    return this.http.post(this.backendUrl + 'user/getBadlaDoller' ,data)
    .pipe(tap(_ => console.log(``)));
  }

  liveBadlaInstruments(data): Observable<any> {
    return this.http.get(this.backendUrl + 'instruments/badlasetting/getInstrument')
    .pipe(tap(_ => console.log(``)));
  }
  liveBadlaInstrumentsMarketWatch(data): Observable<any> {
    return this.http.get(this.backendUrl + 'instruments/badlasetting/getInstrumentMarketWatch')
    .pipe(tap(_ => console.log(``)));
  }

  liveBadlaInstrumentsWithDelete(data): Observable<any> {
    return this.http.get(this.backendUrl + 'instruments/badlasetting/getInstrumentWithDelete')
    .pipe(tap(_ => console.log(``)));
  }
  liveBadlaInstrumentsWithInactive(data): Observable<any> {
    return this.http.get(this.backendUrl + 'instruments/badlasetting/getBadlaInstrumentWithInactive')
    .pipe(tap(_ => console.log(``)));
  }

  getAverageBadla(data)  : Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/averageBadla' ,data)
    .pipe(tap(_ => console.log(``)));
  } 
  saveBadlaOrder(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/addbadlaOrder' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  endBadlaOrder(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/endbadlaOrder' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  editSettleBadlaOrder(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/editSettleBadlaOrder' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  deleteSettleBadlaOrder(data): Observable<any> {
    // let tempUrl = "http://localhost:5050/api/v1/";
    return this.http.post(this.backendUrl + 'instruments/deleteSettleBadlaOrder' ,data)
    .pipe(tap(_ => console.log(``)));
  }

  rolloverBadlaOrder(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/rolloverbadlaOrder' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  settledBadlaOrder(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/settledBadlaOrder' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  deleteBadlaOrder(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/deleteBadlaOrder' ,data)
    .pipe(tap(_ => console.log(``)));    
  }
  getOpeningBalance (data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getOpeningBalance' ,data)
    .pipe(tap(_ => console.log(``)));    
  }
  getDifference (data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getOpeningBalance' ,data)
    .pipe(tap(_ => console.log(``)));    
  }
  getMessage(data): Observable<any> {
    return this.http.get(this.backendUrl + 'instruments/getMessage')
    .pipe(tap(_ => console.log(``)));  
  }

  updateOpeningAmount (data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/updateOpeningAmount' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  updateDollerAmount (data): Observable<any> {
    return this.http.post(this.backendUrl + 'user/updateDollerRateUser' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  updatedifference (data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/updatedifference' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  updateBadlaOrder(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/updatebadlaOrder' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  partialOrder(data): Observable<any> {
    // let tempUrl = "http://localhost:5050/api/v1/";
    return this.http.post(this.backendUrl + 'instruments/partialOrder' ,data)
    .pipe(tap(_ => console.log(``)));
    
  }
  partialOrderSell(data): Observable<any> {
    // let tempUrl = "http://localhost:5050/api/v1/";
    return this.http.post(this.backendUrl + 'instruments/partialOrderSell' ,data)
    .pipe(tap(_ => console.log(``)));
    
  }
  
  getLastPrice(data):Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getBadlaLastPrice' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getSingleBadlaOrder(data):Observable<any>{
    return this.http.post(this.backendUrl + 'instruments/singleBadlaOrder' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getBadlaOrderUniqId(data):Observable<any>{
    return this.http.post(this.backendUrl + 'instruments/getBadlaOrderUniqId' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getOrderInstrument(id):Observable<any> {
    return this.http.get(this.backendUrl + 'instruments/getOrderInstrument/' + id)
    .pipe(tap(_ => console.log(``)));
  }
  getDoller(id):Observable<any> {
    return this.http.get(this.backendUrl + 'instruments/doller/get')
    .pipe(tap(_ => console.log(``)));
  }
  login(data): Observable<any> {
    // const headers = new HttpHeaders({
    //   'Content-Type': 'application/x-www-form-urlencoded',
    //  });
    //  var body = "user_outo_no=" + data.user_outo_no + "&user_pass_auto=" + data.user_pass_auto;

    // return this.http.post('http://dgpluslive.com:8080/DigiPlusWS/LoginBadla.php' ,body,{headers : headers})
    // .pipe(tap(_ => console.log(``)));

    return this.http.post(this.backendUrl + 'instruments/badlaLogin' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  createAuthToken(data): Observable<any> {
    return this.http.post(this.backendUrl + 'user/createAuthToken' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getDuty(data): Observable<any> {
    return this.http.post(this.backendUrl + 'user/createAuthToken' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  addBadlaScriptUser(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/addBadlaScriptUser' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getUserWiseScript(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getBadlaScriptUser' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  deleteBadlaScriptUser(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/deleteBadlaScriptUser' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  updateLimitBadlaScript(data): Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/updateLimitBadlaScript' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getHistoryByDay(data) : Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getHistoryByDay' ,data)
    .pipe(tap(_ => console.log(``)));
  }
  getHistoryByRange(data) : Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/getHistoryByRange' ,data)
    .pipe(tap(_ => console.log(``)));
  }

  deleteAllDetele(data):Observable<any> {
    return this.http.post(this.backendUrl + 'instruments/deleteAllbadla' ,data)
    .pipe(tap(_ => console.log(``)));    
  }


}
